import React, { useContext } from 'react'
import { Flex } from 'rebass'
import { trackHandler, UneeqContext, useUneeqState } from 'uneeq-react-core'
import CloseIcon from '@material-ui/icons/Close'
import styles from './styles'
import { useTranslation } from 'react-i18next'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles, Theme, useTheme } from '@material-ui/core'

const EndSessionButton = () => {
  const theme = useTheme() as any
  const { themeColors } = theme.colors

  const { dispatch, config } = useContext(UneeqContext)
  const { feedbackGiven, contactDetailsGiven } = useUneeqState()
  const { t } = useTranslation()

  const endSession = () => {
    let nextStep
    if (!feedbackGiven) {
      nextStep = 'Feedback'
    } else if (!contactDetailsGiven && config.showEscalationForm) {
      nextStep = 'EscalationForm'
    } else {
      nextStep = 'EndConfirm'
    }
    dispatch({ type: 'open' + nextStep, payload: true })
  }

  const getThemeStyles: any = (theme: Theme) => ({
    closeButton: {
      color: theme.palette.primary.contrastText,
      '&:hover': {
        opacity: 0.8
      }
    }
  })
  const useStyles = makeStyles(getThemeStyles)
  const muiClasses = useStyles()

  return (
    <Flex sx={styles.button}>
      <IconButton
        className={muiClasses.closeButton}
        aria-label={t('endSession.EndSessionButton.leaveChat')}
        onClick={trackHandler(endSession, 'exit-session-btn')}
      >
        <CloseIcon />
      </IconButton>
    </Flex>
  )
}

export default EndSessionButton
